import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWhirlpool = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 262 260",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("line", {
			x1: 14.5282,
			y1: 125.471,
			x2: 15.4485,
			y2: 206.472,
			stroke: "#808080",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 245.528,
			y1: 126.471,
			x2: 246.448,
			y2: 207.472,
			stroke: "#808080",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 72.5296,
			y1: 144.47,
			x2: 73.4701,
			y2: 223.47,
			stroke: "#808080",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108.033 98.108C108.033 98.108 112.923 94.033 119.959 94.0804C126.995 94.1279 132.201 98.2714 132.201 98.2714C132.201 98.2714 137.075 103.221 144.111 103.207C151.147 103.192 156.368 98.4348 156.368 98.4348",
			stroke: "#808080",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.048 41.9373C66.048 41.9373 68.3439 39.1043 68.3004 35.0413C68.257 30.9783 65.8985 27.9811 65.8985 27.9811C65.8985 27.9811 63.0843 25.1766 63.0759 21.1134C63.0675 17.0502 65.749 14.0249 65.749 14.0249",
			stroke: "#808080",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.048 30.9373C131.048 30.9373 133.344 28.1043 133.3 24.0413C133.257 19.9783 130.898 16.9811 130.898 16.9811C130.898 16.9811 128.084 14.1766 128.076 10.1134C128.067 6.05019 130.749 3.02489 130.749 3.02489",
			stroke: "#808080",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M196.048 41.9373C196.048 41.9373 198.344 39.1043 198.3 35.0413C198.257 30.9783 195.898 27.9811 195.898 27.9811C195.898 27.9811 193.084 25.1766 193.076 21.1134C193.067 17.0502 195.749 14.0249 195.749 14.0249",
			stroke: "#808080",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 159.528,
			y1: 148.471,
			x2: 160.403,
			y2: 225.473,
			stroke: "#808080",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M257.5 94.5C257.5 98.9402 254.653 103.618 248.444 108.263C242.279 112.874 233.199 117.133 221.756 120.754C198.897 127.987 167.163 132.5 132 132.5C96.8371 132.5 65.1033 127.987 42.2445 120.754C30.8005 117.133 21.7211 112.874 15.5564 108.263C9.34719 103.618 6.5 98.9402 6.5 94.5C6.5 90.0598 9.34719 85.3823 15.5564 80.7374C21.7211 76.1258 30.8005 71.8667 42.2445 68.2457C65.1033 61.013 96.8371 56.5 132 56.5C167.163 56.5 198.897 61.013 221.756 68.2457C233.199 71.8667 242.279 76.1258 248.444 80.7374C254.653 85.3823 257.5 90.0598 257.5 94.5Z",
			stroke: "#808080",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M257.051 213.567C260.307 218.898 259.476 224.371 254.617 229.599C249.759 234.827 240.99 239.684 228.931 243.825C216.871 247.967 201.815 251.294 184.823 253.57C167.831 255.846 149.318 257.017 130.591 257C111.863 256.982 93.3763 255.777 76.4353 253.47C59.4943 251.162 44.5115 247.808 32.544 243.644C20.5764 239.48 11.9157 234.607 7.17282 229.37C2.42992 224.133 1.72039 218.659 5.09428 213.334V195.5M256.5 213.5V198.5",
			stroke: "#808080",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M246.738 182C254.929 186.98 258.299 192.412 256.55 197.814C254.802 203.216 247.988 208.423 236.713 212.971C225.438 217.52 210.049 221.271 191.911 223.892C173.772 226.513 153.443 227.923 132.724 227.997C112.005 228.071 91.5357 226.807 73.1297 224.317C54.7237 221.827 38.9487 218.188 27.2023 213.721C15.4558 209.255 8.10033 204.1 5.78744 198.712C3.47454 193.324 6.27559 187.87 13.9425 182.833",
			stroke: "#808080",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M244.5 96C244.5 98.3878 242.409 101.43 236.61 104.725C231.007 107.909 222.734 110.859 212.294 113.368C191.453 118.377 162.534 121.5 130.5 121.5C98.4665 121.5 69.5468 118.377 48.7063 113.368C38.2663 110.859 29.993 107.909 24.3903 104.725C18.591 101.43 16.5 98.3878 16.5 96C16.5 93.6122 18.591 90.5701 24.3903 87.2747C29.993 84.0911 38.2663 81.141 48.7063 78.6318C69.5468 73.6229 98.4665 70.5 130.5 70.5C162.534 70.5 191.453 73.6229 212.294 78.6318C222.734 81.141 231.007 84.0911 236.61 87.2747C242.409 90.5701 244.5 93.6122 244.5 96Z",
			stroke: "#808080",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 97V115.094C9.28658 121.196 17.1433 126.971 28.9347 131.953C40.7261 136.935 56.1212 140.983 73.8746 143.771C91.628 146.559 111.241 148.007 131.128 148C151.015 147.992 170.617 146.529 188.349 143.728C206.08 140.927 221.444 136.867 233.197 131.876C244.949 126.885 252.761 121.104 256 115V100.5",
			stroke: "#808080",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgWhirlpool);
export default ForwardRef;
